<div>
  <submission-loading v-if="!isAllReadyStatesComplete()" :id="$vId(this)" />

  <div class="mt-block" v-show="isAllReadyStatesComplete()" v-if="isReadyStateComplete()">
    <div class="mt-wrapper">
      <fou-group bottom="large">
        <fou-container :id="$vId(this)" cols="12" padded background>
          <template #header>
            <div class="mt-flex mt-flex--between">
              <h2 class="mt-h5">{{$t('pages.submissions.edit.title')}}</h2>
              <div :class="$style.editTag">
                <span class="mt-serif mt-serif--size3" :class="$style.editTagInner"
                  >{{$t('pages.submissions.edit.tag')}}</span
                >
              </div>
            </div>
          </template>

          <template #content>
            <v-grid>
              <v-row class="mt-group">
                <v-col has="10" off="1">
                  <fou-accordion :class="$style.accordion">
                    <fou-accordion-item open :class="$style.item" :id="$vId(this, 'edit-upload-section')">
                      <template #heading>
                        <div :class="[$style.headingUpload, $style.heading]">
                          <h2 class="mt-h2" :class="$style.title">
                            {{$t('pages.submissions.components.upload.heading')}}
                          </h2>
                        </div>
                      </template>
                      <template #content>
                        <div :class="$style.accordionContent">
                          <results :id="$vId(this)"></results>
                          <designers :id="$vId(this)"></designers>
                          <defaultStyle :id="$vId(this)"></defaultStyle>
                        </div>
                      </template>
                    </fou-accordion-item>

                    <fou-accordion-item :class="$style.item" :id="$vId(this, 'edit-prices-section')">
                      <template #heading>
                        <div :class="[$style.headingPrices, $style.heading]">
                          <h2 class="mt-h2" :class="$style.title">
                            {{$t('pages.submissions.components.prices.heading')}}
                          </h2>
                        </div>
                      </template>
                      <template #content>
                        <prices :id="$vId(this)" :class="$style.accordionContent"></prices>
                      </template>
                    </fou-accordion-item>

                    <fou-accordion-item :class="$style.item" :id="$vId(this, 'edit-descriptions-section')">
                      <template #heading>
                        <div :class="[$style.headingDesc, $style.heading]">
                          <h2 class="mt-h2" :class="$style.title">
                            {{$t('pages.submissions.components.descriptions.heading')}}
                          </h2>
                        </div>
                      </template>
                      <template #content>
                        <descriptions :id="$vId(this)" :class="$style.accordionContent"> </descriptions>
                      </template>
                    </fou-accordion-item>
                    <fou-accordion-item :class="$style.item" :id="$vId(this, 'edit-graphics-section')">
                      <template #heading>
                        <div :class="[$style.headingImages, $style.heading]">
                          <h2 class="mt-h2" :class="$style.title">
                            {{$t('pages.submissions.components.graphics.heading')}}
                          </h2>
                        </div>
                      </template>
                      <template #content>
                        <graphics :id="$vId(this)" :class="$style.accordionContent"> </graphics>
                      </template>
                    </fou-accordion-item>
                  </fou-accordion>
                </v-col>
              </v-row>
            </v-grid>
          </template>
        </fou-container>
      </fou-group>

      <fou-group>
        <button :disabled="!enableButton" type="button" class="mt-button" @click="navigateToReview">
          {{$t('pages.submissions.edit.action.review')}}
        </button>
      </fou-group>
    </div>
  </div>
</div>
